import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import flatpickr from 'flatpickr';
import cx from 'classnames';
import dayjs from 'dayjs';
import helpers from '../../resources/helpers';

import FormElementWrapper from '../core/FormElementWrapper';

import './DatePicker.scss';

class DatePicker extends React.Component {
	constructor(props) {
		super(props);

		this.inputRef = React.createRef();
		this.state = {
			hasFocus: false,
			touched: false,
			value: props.value,
			hasValue: (props.value || '') !== '',
		};
		this.handleLabelClick = this.handleLabelClick.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleValueChange = this.handleValueChange.bind(this);
	}

	componentDidMount() {
		const flatpickrFormat = this.props.includeTime ? 'F d Y h:i K' : 'F d Y';
		flatpickr(this.inputRef.current, {
			enableTime: this.props.includeTime,
			dateFormat: flatpickrFormat,
			onChange: (selectedDates) => {
				const value = selectedDates[0];
				this.handleValueChange(value);
			},
		});
	}

	componentWillReceiveProps(props) {
		this.setState({
			value: props.value,
			hasValue: (props.value || '') !== '',
		});
	}

	// Event Handlers
	handleLabelClick() {
		this.inputRef.current.focus();
	}

	handleFocus() {
		if (this.props.onFocus) {
			this.props.onFocus();
		}
		this.setState({
			hasFocus: true,
			touched: true,
		});
	}

	handleValueChange(value) {
		this.props.setValue(value);
		if (this.props.onChange) {
			this.props.onChange(value, this.state.touched);
		}
		this.setState({
			value,
			hasValue: true,
		});
	}

	render() {
		const props = this.props;

		const dateFormat = this.props.includeTime ? 'MMMM DD YYYY h:mm A' : 'MMMM DD YYYY';
		const displayValue = this.state.value ? dayjs(this.state.value).format(dateFormat) : '';

		const { showError, errorMessage } = helpers.shouldComponentShowError({
			showError: this.props.showError,
			formHasHadAnInValidSubmit: this.props.formHasHadAnInValidSubmit,
			required: this.props.required,
			getErrorMessage: () => props.errorMessage,
			errorMessage: props.errorMessage,
			currentValue: displayValue,
		});

		return (
			<FormElementWrapper
				label={props.label}
				hideLabel={props.hideLabel}
				tooltip={props.tooltip}
				optionalLabel={props.optionalLabel}
				name={props.name}
				required={props.required}
				hasFocus={this.state.hasFocus}
				hasValue={this.state.hasValue}
				showError={showError}
				errorMessage={errorMessage}
				onLabelClick={this.handleLabelClick}>
				<input
					ref={this.inputRef}
					className={cx('date-picker__input', { 'date-picker__has-error': showError })}
					onFocus={this.handleFocus}
					onBlur={() => this.setState({ hasFocus: false })}
					onChange={(evt) => this.handleValueChange(evt.currentTarget.value)}
					name={props.name}
					value={displayValue || ''}
				/>
			</FormElementWrapper>
		);
	}
}

DatePicker.propTypes = {
	required: PropTypes.bool,
	hidden: PropTypes.bool,
	hideLabel: PropTypes.bool,
	lockLabel: PropTypes.bool,
	label: PropTypes.string,
	tooltip: PropTypes.string,
	optionalLabel: PropTypes.string,
	className: PropTypes.string,
	showError: PropTypes.any,
	errorMessage: PropTypes.string,
	getErrorMessage: PropTypes.func,
	name: PropTypes.string.isRequired,
	value: PropTypes.any,
	onChange: PropTypes.func,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	includeTime: PropTypes.bool,
	formHasHadAnInValidSubmit: PropTypes.bool,
};

export default withFormsy(DatePicker);
